const isDevelopment = process.env.NODE_ENV === 'development';

// Logs sécurisés - uniquement en développement
export const devLog = (...args) => {
  if (isDevelopment) {
    console.log(...args);
  }
};

export const devError = (...args) => {
  if (isDevelopment) {
    console.error(...args);
  }
};

export const devWarn = (...args) => {
  if (isDevelopment) {
    console.warn(...args);
  }
};

// Pour les logs de production (très limités et sécurisés)
export const prodLog = (message, level = 'info') => {
  if (level === 'error') {
    console.error(`[${new Date().toISOString()}] ${message}`);
  } else {
    console.log(`[${new Date().toISOString()}] ${message}`);
  }
};

// Utilitaire pour nettoyer les données sensibles
export const sanitizeForLog = (data) => {
  if (!isDevelopment) return '[HIDDEN]';
  
  if (typeof data === 'object' && data !== null) {
    const sanitized = { ...data };
    
    // Supprimer les champs sensibles
    if (sanitized.token) sanitized.token = '[TOKEN_HIDDEN]';
    if (sanitized.password) sanitized.password = '[PASSWORD_HIDDEN]';
    if (sanitized.email) sanitized.email = sanitized.email.replace(/(.{2}).*(@.*)/, '$1***$2');
    
    return sanitized;
  }
  
  return data;
}; 